module.exports = __webpack_public_path__ + "img/814.95f396f6.png";